import { io } from 'socket.io-client';

import { SOCKET_USER_CONNECT_EVENT, SOCKET_USER_LOGIN_EVENT } from '../config/constants';

import { firebaseAuth } from './firebase';

const { VITE_API_URL } = import.meta.env;

if (!VITE_API_URL) {
  throw new Error('VITE_API_URL is not defined');
}

const ROOT_URL = VITE_API_URL;

const handleSocketConnect = async (socketInstance: ReturnType<typeof io>) => {
  const { pathname } = window.location;
  const token = await firebaseAuth.currentUser?.getIdToken();
  socketInstance.emit(SOCKET_USER_LOGIN_EVENT, { token, pathname });
};

export const socket = io(`${ROOT_URL}/wallet`, {
  transports: ['websocket'],
  path: '/api/socket',
  autoConnect: false,
});

socket.on(SOCKET_USER_CONNECT_EVENT, () => handleSocketConnect(socket));

export const metagameSocket = io(`${ROOT_URL}/metagame`, {
  transports: ['websocket'],
  path: '/api/socket',
  autoConnect: false,
});

metagameSocket.on(SOCKET_USER_CONNECT_EVENT, () => handleSocketConnect(metagameSocket));
